<template>
  <div class="has-tooltip inline-block">
    <span
      class="tooltip rounded-xl shadow-lg p-2 bg-white border-primary-300 border text-gray-800 -mt-11"
      ref="tooltip"
      ><slot name="tooltip"></slot
    ></span>
    <p ref="text"><slot name="text"></slot></p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$refs.tooltip.style.marginLeft =
      (this.$refs.text.clientWidth - this.$refs.tooltip.clientWidth) / 2 + "px";
  },
};
</script>